import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import { DownloadsAnalytics } from '../components/DownloadsAnalytics';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { hasPermission } from '../types/userTypes';

export const AdminDownloadsPage: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState<any>(null);
  const [profileLoading, setProfileLoading] = useState(true);

  // Check permissions - fallback to content_management or admin status
  const canManageProducts = userProfile && (
    (userProfile.role && hasPermission(userProfile.role, 'product_management', userProfile.adminPermissions)) ||
    (userProfile.role && hasPermission(userProfile.role, 'content_management', userProfile.adminPermissions)) ||
    userProfile.isAdmin === true
  );

  // Fetch user profile
  useEffect(() => {
    const fetchUserProfile = async () => {
      if (!currentUser) {
        setProfileLoading(false);
        return;
      }
      
      try {
        setProfileLoading(true);
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists()) {
          setUserProfile(userDoc.data());
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
      } finally {
        setProfileLoading(false);
      }
    };

    fetchUserProfile();
  }, [currentUser]);

  useEffect(() => {
    // Don't redirect while profile is still loading
    if (profileLoading) return;
    
    if (!canManageProducts) {
      console.log('No permission to view downloads. UserProfile:', userProfile);
      navigate('/admin');
      return;
    }
  }, [canManageProducts, navigate, profileLoading, userProfile]);

  if (profileLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <Typography>Loading...</Typography>
      </Box>
    );
  }

  if (!canManageProducts) {
    return null;
  }

  return (
    <Box sx={{ flexGrow: 1, py: 3 }}>
      <Container maxWidth="xl">
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Download Analytics
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Track and analyze product downloads across all loyalty levels
          </Typography>
        </Box>

        <Card>
          <CardContent>
            <DownloadsAnalytics />
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}; 